import { mutator } from 'satcheljs';
import getStore from '../store/store';
import selectReminderDefaultTimeOption from '../../actions/selectReminderDefaultTimeOption';
/**
 * Called when there is a change in the default reminder dropdown
 */
export default mutator(selectReminderDefaultTimeOption, function (actionMessage) {
    var defaultReminderTime = actionMessage.defaultReminderTime;
    getStore().defaultReminderTime = defaultReminderTime;
});
//# sourceMappingURL=selectReminderDefaultTimeOption.js.map